// extracted by mini-css-extract-plugin
export default {"folderDownloadButton":"FolderDownloadButton_folderDownloadButton__mCIn2","folderIcon":"FolderDownloadButton_folderIcon__VNZyW"};